@if (showPreviousPocketDepth()) {
  <div
    class="absolute left-[-67px] h-[110px] w-[57px] rounded-[22px] bg-background-white p-2 shadow-card"
    [ngClass]="{ 'top-[96px]': isBottomConfigDisabled(), 'top-[396px]': !isBottomConfigDisabled() }"
  >
    <lib-perio-next-pocket-depth
      [toothPosition]="previousTooth()!.position"
      [toothSide]="previousToothSide()"
      [tooth]="previousTooth()"
    ></lib-perio-next-pocket-depth>
  </div>
}
<!-- @if (showPreviousRecession()) {
  <div
    class="absolute left-[-67px] h-[110px] w-[57px] rounded-[22px] bg-background-white p-2 shadow-card"
    [ngClass]="{ 'top-[398px]': isBottomConfigDisabled(), 'top-[396px]': !isBottomConfigDisabled() }"
  >
    <lib-perio-next-pocket-depth
      [toothPosition]="previousTooth()!.position"
      [toothSide]="previousToothSide()"
      [tooth]="previousTooth()"
    ></lib-perio-next-pocket-depth>
  </div>
} -->
<div class="relative flex">
  <div class="grid w-[413px] grid-cols-12">
    <!-- Add Tooth selector -->
    @if (typeSafeModifedTooth(); as tooth) {
      <div class="col-span-full mb-3 flex items-center gap-2">
        <lib-perio-form-tooth-navigator
          class="flex-grow"
          [toothNumber]="tooth.position"
          [activeJaw]="activeJaw() ?? 'upper'"
          [isFirstTooth]="isFirstTooth()"
          [isLastTooth]="isLastTooth()"
          [currentSide]="currentSide()"
          (stepBackward)="onMoveToPreviousToothManually()"
          (stepForward)="onMoveToNextToothManually()"
          (switchToLingual)="onSwitchToLingualManually()"
          (switchToFacial)="onSwitchToFacialManually()"
          (switchToOppositeJawLingual)="onSwitchToOppositeJawLingualManually($event)"
        />
      </div>
      <!-- @if (isAiThinking()) {
        <ng-lottie size="small" currentcolor class="absolute top-[105px] h-3 w-full" [options]="lottieThinkingOptions"></ng-lottie>
      } -->

      <!-- Input Mode Dropdown - positioned in top right corner -->
      <div class="absolute right-0 top-[28px] z-10">
        <button
          class="flex items-center gap-1.5 rounded-2xl border-[1.8px] border-background-light-grey bg-background-white p-1.5 transition-colors"
          (click)="onToggleDropdown()"
          type="button"
        >
          <span
            class="h-4 w-4 rounded-full"
            [ngClass]="{
              'bg-states-purple': inputMode() === 'pocketDepth',
              'bg-states-pink': inputMode() === 'recession'
            }"
          ></span>
          <svg-icon
            key="px-16-arrow-down"
            size="sm"
            class="text-primary-blue transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isInputModeDropdownOpen() }"
          />
        </button>

        @if (isInputModeDropdownOpen()) {
          <div
            class="border-white bg-background-white/86 absolute right-0 top-full mt-1 w-[224px] rounded-3xl px-2 pb-2 pt-3 shadow-[0px_40px_64px_0px_rgba(10,72,131,0.16)] backdrop-blur-md"
          >
            <div class="px-2 pb-1">
              <span class="text-h7 text-text-tertiary">Input mode</span>
            </div>
            <button
              class="flex w-full items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-background-light-grey"
              (click)="onSelectInputMode('pocketDepth')"
              type="button"
            >
              <span class="h-3 w-3 shrink-0 rounded-full bg-states-purple"></span>
              <span
                class="flex-grow text-left text-h4 text-text-primary"
                [ngClass]="{
                  'font-semibold': inputMode() === 'pocketDepth',
                  'font-light': inputMode() !== 'pocketDepth'
                }"
              >
                Pocket depth
              </span>
              @if (inputMode() === 'pocketDepth') {
                <span class="flex h-6 w-6 items-center justify-center rounded-full bg-[rgba(52,238,183,0.16)]">
                  <svg-icon key="px-16-check" size="sm" class="text-secondary-electric-green" />
                </span>
              }
            </button>
            <button
              class="flex w-full items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-background-light-grey"
              (click)="onSelectInputMode('recession')"
              type="button"
            >
              <span class="h-3 w-3 shrink-0 rounded-full bg-states-pink"></span>
              <span
                class="flex-grow text-left text-h4 text-text-primary"
                [ngClass]="{
                  'font-semibold': inputMode() === 'recession',
                  'font-light': inputMode() !== 'recession'
                }"
              >
                Recession
              </span>
              @if (inputMode() === 'recession') {
                <span class="flex h-6 w-6 items-center justify-center rounded-full bg-[rgba(52,238,183,0.16)]">
                  <svg-icon key="px-16-check" size="sm" class="text-secondary-electric-green" />
                </span>
              }
            </button>
          </div>
        }
      </div>
      <div class="col-span-4 mb-12 h-full">
        @for (t of [tooth]; track t.jaw + '-' + currentSide()) {
          <lib-perio-exam-tooth class="h-full flex-grow" [tooth]="t" [teeth]="teeth()" [activeSide]="currentSide()"></lib-perio-exam-tooth>
        }
      </div>
      <div class="col-span-8 flex flex-col justify-between gap-4">
        <lib-perio-config
          [measurements]="!reveresedJawOrder() ? buccal()! : lingual()!"
          [side]="!reveresedJawOrder() ? 'buccal' : 'lingual'"
          [showTitle]="true"
          [disabled]="isTopConfigDisabled()"
          [isCentralRecession]="isCentralRecession()"
          [toothPosition]="tooth.position"
          (perioChanges)="onPerioChanged($event)"
          [voiceModeActive]="isVoiceActive()"
          (toothSidePerioDone)="onToothSidePerioDone($event)"
        ></lib-perio-config>
        <lib-perio-jaw-related-measurements
          [measurements]="jawRelatedMeasurements()"
          [fgDisabled]="!(tooth.position | hasFg)"
          [reversed]="reversedMeasurement()"
          (measurementChange)="onJawMeasurementsChanged($event)"
        ></lib-perio-jaw-related-measurements>
        <lib-perio-config
          [measurements]="!reveresedJawOrder() ? lingual()! : buccal()!"
          [side]="!reveresedJawOrder() ? 'lingual' : 'buccal'"
          [showTitle]="false"
          [disabled]="isBottomConfigDisabled()"
          [isCentralRecession]="isCentralRecession()"
          [toothPosition]="tooth.position"
          (perioChanges)="onPerioChanged($event)"
          [voiceModeActive]="isVoiceActive()"
          (toothSidePerioDone)="onToothSidePerioDone($event)"
        ></lib-perio-config>
      </div>
    }
  </div>

  @if (cheatSheetOpened()) {
    <lib-perio-cheat-sheet
      class="ml-4 mt-22"
      [isBottomConfigDisabled]="isBottomConfigDisabled()"
      [isTopConfigDisabled]="isTopConfigDisabled()"
      @fadeIn
    />
  }
</div>
@if (showNextPocketDepth()) {
  <div
    class="absolute right-[-67px] h-[110px] w-[57px] rounded-[22px] bg-background-white p-2 shadow-card"
    [ngClass]="{ 'top-[96px]': isBottomConfigDisabled(), 'top-[396px]': !isBottomConfigDisabled() }"
  >
    <lib-perio-next-pocket-depth
      [toothPosition]="nextTooth()!.position"
      [toothSide]="nextToothSide()"
      [tooth]="nextTooth()"
    ></lib-perio-next-pocket-depth>
  </div>
}
<!-- @if (showNextRecession()) {
  <div
    class="absolute right-[-67px] h-[110px] w-[57px] rounded-[22px] bg-background-white p-2 shadow-card"
    [ngClass]="{ 'top-[96px]': isBottomConfigDisabled(), 'top-[396px]': !isBottomConfigDisabled() }"
  >
    <lib-perio-next-pocket-depth
      [toothPosition]="nextTooth()!.position"
      [toothSide]="nextToothSide()"
      [tooth]="nextTooth()"
    ></lib-perio-next-pocket-depth>
  </div>
} -->

<div
  class="cheat-sheet-toggler absolute right-0 top-[300px] -mr-[87px] flex h-8 w-[143px] -translate-y-4 rotate-90 cursor-pointer items-center justify-center gap-2 rounded-t-2xl bg-states-white backdrop-blur-modal"
  (click)="onToggleCheatSheet()"
>
  <span> Shortcuts </span>
  <svg-icon
    [ngClass]="{
      'rotate-180': !cheatSheetOpened()
    }"
    key="px-16-arrow-down"
    size="sm"
    class="text-text-blue transition-all duration-300"
  />
</div>
